import { Card, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { green, red } from '@mui/material/colors';
import { format } from 'date-fns';
import { FC } from 'react';
import {
	PaymentInstallmentsMessageModel,
	SplitPaymentPlanModel,
	SplitPaymentStatus,
} from '@acorn-portal/shared/src/services/api';
import { formatCurrency } from '@acorn-portal/shared/src/utils';
import { DISPLAY_DATE } from '@acorn-portal/shared/src/utils/constants';

interface IPaymentScheduleTable {
	splitPaymentPlans?: SplitPaymentPlanModel[];
	installments?: PaymentInstallmentsMessageModel[];
}

const getStatusColor = (status: SplitPaymentStatus) => {
	if (status === SplitPaymentStatus.Paid) {
		return green[50];
	}
	if (status === SplitPaymentStatus.Overdue) {
		return red[50];
	}
	return 'white';
};

const PaymentScheduleTable: FC<IPaymentScheduleTable> = ({ splitPaymentPlans, installments }) => {
	return (
		<Card variant='outlined' sx={{ borderRadius: 2 }}>
			<TableContainer component={Paper}>
				<Table
					sx={(theme) => ({
						minWidth: 250,
						borderColor: theme.palette.divider,
						'& .MuiTableCell-root': {
							fontSize: '1.02rem',
						},
					})}
					aria-label='simple table'
				>
					<TableHead>
						<TableRow sx={{ fontWeight: 'bold' }}>
							<TableCell>Payment Date</TableCell>
							<TableCell align='right'>Amount</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{splitPaymentPlans?.map((splitPayment) => (
							<TableRow
								key={splitPayment.splitPaymentId}
								sx={{
									backgroundColor: getStatusColor(splitPayment.status),
									'&:last-child td, &:last-child th': {
										border: 0,
									},
								}}
							>
								<TableCell component='th' scope='row'>
									{format(new Date(splitPayment.dateOfPayment), DISPLAY_DATE)}
								</TableCell>
								<TableCell align='right'>{formatCurrency(splitPayment.amount)}</TableCell>
							</TableRow>
						))}

						{installments?.map((installment) => (
							<TableRow
								key={installment.installmentNumber}
								sx={{
									'&:last-child td, &:last-child th': {
										border: 0,
									},
								}}
							>
								<TableCell component='th' scope='row'>
									{installment.dueDate && format(new Date(installment.dueDate), DISPLAY_DATE)}
								</TableCell>
								<TableCell align='right'>{formatCurrency(Number(installment.amount))}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Card>
	);
};

export default PaymentScheduleTable;
